<template>
  <el-container>
    <el-aside width="8%" v-if="$route.meta.inLayout1">
      <el-row>
        <el-col :lg="24" style="margin-bottom: 20px">
          <span style="color: #fff; font-weight: bold; font-size: 20px; max-width: 100%"
            >詩芙儂後臺管理中心</span
          >
        </el-col>
        <el-col :lg="24">
          <el-menu
            background-color="#545c64"
            text-color="#fff"
            mode="vertical"
            router
            style="border: #545c64"
          >
            <el-menu-item index="/notice">最新消息</el-menu-item>
            <el-menu-item index="/member">會員</el-menu-item>
            <el-menu-item index="/shop">店櫃</el-menu-item>
            <el-menu-item index="/product">商品</el-menu-item>
            <el-submenu index="1">
              <template slot="title">
                <span style="font-size: 16px">訂單</span>
              </template>
              <el-menu-item index="/order">銷貨</el-menu-item>
              <el-menu-item index="/orderReturn">退貨</el-menu-item>
            </el-submenu>
            <el-menu-item index="/coupon">禮卷</el-menu-item>
            <el-menu-item index="/performance">業績</el-menu-item>
            <el-menu-item index="/">員工</el-menu-item>
            <el-menu-item index="/memberpoint">兌換中心</el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
      <el-row style="margin-top: 200px">
        <el-col :lg="24">
          <span style="color: #fff">2021-03-18 version 17</span>
        </el-col>
      </el-row>
    </el-aside>

    <el-container>
      <el-header v-if="$route.meta.inLayout2" height="7vh">
        <el-row>
          <el-col :lg="1" :offset="23">
            <span v-if="isLoggedIn">
              <el-button type="primary"
                ><a @click="logout">{{ this.users.user_id }}</a></el-button
              >
            </span>
          </el-col>
        </el-row>
      </el-header>

      <el-main>
        <router-view v-if="routerAlive"></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Layout",
  data() {
    return {
      isCollapse: false,
      users: {},
      user_id: "",
      routerAlive: true,
    };
  },
  provide() {
    return {
      routerRerfresh: this.routerRefresh,
    };
  },
  computed: {
    key() {
      return this.$route.path + Math.random();
    },
    ...mapGetters(["getUserItem"]),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    changeCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async logout() {
      await this.$store.dispatch("logout");
      this.users = {};
      this.$emit("logout");
    },

    LoginUser() {
      this.users = JSON.parse(localStorage.getItem("user"));
    },
  },
  async created() {
    this.LoginUser();
  },
};
</script>

<style lang="scss">
.el-container {
  height: 100%;
  padding: 0;
  margin: 0;
  width: 100%;
}

.el-header {
  width: 100%;
  background-color: #545c64;
}

.el-menu-item {
  font-size: 18px;
}

.el-main {
  width: 100%;
}

aside {
  background-color: #545c64;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.el-container /deep/ .el-main {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
